import { render, staticRenderFns } from "./ReceivingClose.vue?vue&type=template&id=915c8e60"
import script from "./ReceivingClose.vue?vue&type=script&lang=js"
export * from "./ReceivingClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports